import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.common.requestSelectors.Xero', {
    lockDateOverrideWarning:
        'When approved, the date will change to {newDate} because the lock date is set as {lockDate}.',
});
